interface HamburgerButtonProps {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}

export function HamburgerButton({ sidebarOpen, setSidebarOpen }: HamburgerButtonProps) {
  return (
    <button
      className="text-gray-500 hover:text-gray-600 dark:hover:text-gray-400 lg:hidden"
      aria-controls="sidebar"
      aria-expanded={sidebarOpen}
      onClick={(e) => {
        e.stopPropagation();
        setSidebarOpen(!sidebarOpen);
      }}
    >
      <span className="sr-only">Öppna meny</span>
      <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="5" width="16" height="2" />
        <rect x="4" y="11" width="16" height="2" />
        <rect x="4" y="17" width="16" height="2" />
      </svg>
    </button>
  );
}
